import { useQuery } from "@tanstack/react-query";

import { CHANNEL_CACHE_KEYS } from "./keys";

import { isMockEnabled, simulateDelay } from "@/mock/config";
import { getChannelMock } from "@/mock/handlers/channel";
import { Channel } from "@/types/channel";
import { Response } from "@/types/pagination";

import { api } from "@/lib/api-client";

export const useGetChannel = (channelId: string) => {
  return useQuery({
    queryKey: CHANNEL_CACHE_KEYS.detail(channelId),
    queryFn: async () => {
      if (isMockEnabled()) {
        await simulateDelay();
        const channel = getChannelMock(channelId);
        if (!channel) {
          throw new Error(`Failed to fetch channel with id ${channelId}`);
        }
        return channel;
      }

      const { data } = await api
        .get(`channels/${channelId}`)
        .json<Response<Channel>>();

      return data;
    },
    enabled: Boolean(channelId),
    retry: false,
  });
};
